// extracted by css-extract-rspack-plugin
var _1 = "src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__description-cHCagS";
var _2 = "src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__emptyChat-oszlm1";
var _3 = "src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__emptyChatContainer-Tm7feZ";
var _4 = "src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__icon-A5Km89";
var _5 = "src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__title-YALsUp";
export { _1 as "description", _2 as "emptyChat", _3 as "emptyChatContainer", _4 as "icon", _5 as "title" }

    if(module.hot) {
      (function() {
        var localsJsonString = "{\"description\":\"src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__description-cHCagS\",\"emptyChat\":\"src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__emptyChat-oszlm1\",\"emptyChatContainer\":\"src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__emptyChatContainer-Tm7feZ\",\"icon\":\"src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__icon-A5Km89\",\"title\":\"src-components-RightBar-MessageList-EmptyChat-EmptyChat-module__title-YALsUp\"}";
        // 1752373455124
        var cssReload = require("../../../../../node_modules/.pnpm/@rspack+core@1.4.6_@swc+helpers@0.5.17/node_modules/@rspack/core/dist/cssExtractHmr.js").cssReload(module.id, {});
        // only invalidate when locals change
        if (
          module.hot.data &&
          module.hot.data.value &&
          module.hot.data.value !== localsJsonString
        ) {
          module.hot.invalidate();
        } else {
          module.hot.accept();
        }
        module.hot.dispose(function(data) {
          data.value = localsJsonString;
          cssReload();
        });
      })();
    }
  